import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link } from "react-router-dom";
import { clearSession, getEmail, getToken } from "utils/authStorage";

const Navbar = (props) => {
  const { onOpenSidenav, brandText } = props;
  const navigate = useNavigate();
  const email = getEmail() || "Admin";

  const onLogout = () => {
    clearSession();
    navigate("/auth/sign-in", { replace: true });
  };

  if (!getToken()) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return (
    <nav className="sticky top-2 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 px-2 py-1.5 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <span className="text-sm font-normal text-navy-700 dark:text-white">
            Pages
            <span className="mx-1 text-sm text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </span>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-xl font-bold capitalize text-navy-700 dark:text-white">
          <span className="font-bold capitalize">{brandText}</span>
        </p>
      </div>

      <div className="relative mt-[3px] flex w-full cursor-pointer items-center justify-between rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 sm:w-fit">
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>

        <Dropdown
          button={
            <div className="flex items-center gap-2 px-2 py-1">
              <div className="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-r from-[#4C3FE8] to-[#A855F7] text-sm font-bold text-white">
                {email.charAt(0).toUpperCase()}
              </div>
              <span className="hidden pr-2 text-sm font-medium text-navy-700 sm:block">
                {email}
              </span>
            </div>
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <p className="text-sm font-bold text-navy-700 dark:text-white">
                  {email}
                </p>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />
              <div className="flex flex-col p-4">
                <button
                  type="button"
                  onClick={onLogout}
                  className="text-left text-sm font-medium text-red-500 transition duration-150 ease-out hover:text-red-500 hover:ease-in"
                >
                  Log Out
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
